import {
  ENDPOINT_RECOMMANDATION_STATUS_ONBOARDING_VISTORIA_ANTECIPADA,
  API_FINANCEIRO_NAME,
  ENDPOINT_CHECKLIST,
  ENDPOINT_CHECKLIST_SUBMIT,
  ENDPOINT_VISTORIA_LOGIN,
  ENDPOINT_DOWNLOAD_LAUDO,
  ENDPOINT_VA_EC_DOWNLOADS,
  ENDPOINT_DOWNLOAD_DOCUMENTS_VA_EC
} from "utils/constants";
import { axiosInstance } from "../servicesSetup";

export const getStatusVA = async () => {
  const instance = await axiosInstance(null, API_FINANCEIRO_NAME);
  return instance.get(
    ENDPOINT_RECOMMANDATION_STATUS_ONBOARDING_VISTORIA_ANTECIPADA
  );
};

export const getChecklist = async idUnidade => {
  const instance = await axiosInstance();
  return instance.get(ENDPOINT_CHECKLIST, {
    params: {
      idUnidade
    }
  });
};

export const getChecklistByIdVistoria = async numeroOcorrencia => {
  const instance = await axiosInstance();
  return instance.get(ENDPOINT_CHECKLIST, {
    params: {
      numeroOcorrencia
    }
  });
};

export const postChecklist = async (checklistList, idUnidade) => {
  const instance = await axiosInstance();
  return instance.post(ENDPOINT_CHECKLIST_SUBMIT, checklistList, {
    params: {
      idUnidade
    }
  });
};

export const postVistoriaLogin = async (cpf, email) => {
  const instance = await axiosInstance();
  return instance.post(
    ENDPOINT_VISTORIA_LOGIN,
    {
      cpf,
      email
    },
    {
      params: {
        tipo: "VA"
      }
    }
  );
};

export const postVistoriaLoginCohab = async (
  cpf,
  email,
  nome,
  numeroOcorrencia
) => {
  const instance = await axiosInstance();
  return instance.post(
    ENDPOINT_VISTORIA_LOGIN,
    {
      cpf,
      email,
      nome,
      numeroOcorrencia
    },
    {
      params: {
        cohab: true
      }
    }
  );
};

export const downloadLaudo = async idUnidade => {
  const instance = await axiosInstance();
  const { data } = await instance.get(ENDPOINT_DOWNLOAD_LAUDO, {
    params: {
      idUnidade
    },
    responseType: "blob"
  });
  return data;
};

export const vaEcDownloads = async idUnidade => {
  const instance = await axiosInstance();
  const { data } = await instance.get(ENDPOINT_VA_EC_DOWNLOADS, {
    params: {
      idUnidade
    }
  });
  return data;
};

export const downloadLaudoNew = async idUnidade => {
  const instance = await axiosInstance();
  const { data } = await instance.get(ENDPOINT_DOWNLOAD_DOCUMENTS_VA_EC, {
    params: {
      unidadeId: idUnidade,
      tipo: "VA"
    },
    responseType: "blob"
  });
  return data;
};
